import { User } from '@adsk/alloy-provider';

export enum PlangridProjectRoleId {
  Admin = '9d139e64-cac9-4f23-b4d5-9fd3688b498e',
  Collaborator = '17dce2c5-4931-47e7-8c98-84b35f00ba03',
}

export const transformHQUserToPgUser = (user: User) => ({
  user_id: user.autodeskId,
  status: user.status === 'active' ? 'joined' : 'removed',
  first_name: user.firstName,
  last_name: user.lastName,
  email: user.email,
  phone: user.phone?.number || '',
  title: user.jobTitle,
  photo_uid: user.imageUrl,
  urls: {
    photo_file: '',
    photo_thumbnail: '',
    logo_file: '',
    logo_thumbnail: '',
  },
  allowed_roles: user.accessLevels?.projectAdmin
    ? [PlangridProjectRoleId.Admin, PlangridProjectRoleId.Collaborator]
    : [PlangridProjectRoleId.Collaborator],
  role_uid: user.accessLevels?.projectAdmin
    ? PlangridProjectRoleId.Admin
    : PlangridProjectRoleId.Collaborator,
  groups: [],
});

export const transformHQUsersToPgUsersResponse = (users: User[]) =>
  users
    .map((user) => transformHQUserToPgUser(user))
    .filter((user) => !!user.user_id);
